/** RPT permission codes — mirrors api/src/modules/rpt/permissions.ts. */
export const P = {
  run: 'rpt.report.run',
  runReadAll: 'rpt.run.read_all',
  dashboard: {
    platform: 'rpt.dashboard.platform',
    founder: 'rpt.dashboard.founder',
    investor: 'rpt.dashboard.investor',
    finance: 'rpt.dashboard.finance',
    sales: 'rpt.dashboard.sales',
    admin: 'rpt.dashboard.admin',
    configure: 'rpt.dashboard.configure',
  },
  schedule: { manage: 'rpt.schedule.manage', manageAll: 'rpt.schedule.manage_all', external: 'rpt.schedule.external_recipients' },
  builder: { use: 'rpt.builder.use', share: 'rpt.builder.share' },
} as const;

/** Any role dashboard (the list page filters to the ones I hold). */
export const ANY_DASHBOARD = [
  P.dashboard.founder,
  P.dashboard.investor,
  P.dashboard.finance,
  P.dashboard.sales,
  P.dashboard.admin,
];
export const ANY_SCHEDULE = [P.schedule.manage, P.schedule.manageAll];
